import { Modal } from 'react-responsive-modal';
import { X } from '@phosphor-icons/react';
import { SchedulerAccessModalContent } from 'src/pages/AuthPages/components/SchedulerAccessModalContent';
import React from 'react';

type SchedulerAccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SVG_SIZE = 24;

export const SchedulerAccessModal = ({
  isOpen,
  onClose,
}: SchedulerAccessModalProps) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      container={document.body}
      classNames={{
        root: 'nj-modal--root',
        overlay: 'nj-modal--overlay',
        modal: 'nj-modal--access nj-auth-access-modal',
        closeIcon: 'nj-video-avatar-modal-closeButton',
      }}
      closeIcon={<X size={SVG_SIZE} />}
      center
    >
      <SchedulerAccessModalContent onCloseModal={onClose} />
    </Modal>
  );
};
